export enum FixedWrapAroundCornerKey {
  None = 'none',
  GableWraparound = 'gable-wraparound',
  StandardWraparound = 'standard-wraparound',
  StandardCarportWraparound = 'standard-carport-wraparound',
}
